import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import advanceFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(advanceFormat);
dayjs.extend(utc);

const isDST = () => {
  const now = new Date();
  const jan = new Date(now.getFullYear(), 0, 1).getTimezoneOffset(); //?
  const jul = new Date(now.getFullYear(), 6, 1).getTimezoneOffset(); //?
  return Math.max(jan, jul) !== now.getTimezoneOffset();
};

dayjs.isDST = isDST;

export default dayjs;
